// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DBHealth_mariadbPage__vfoLf,
.DBHealth_mysqlPage__wzb9D,
.DBHealth_postgresqlPage__fX\\+vg {
  height: 100%;
  width: 100%;
  position: relative;
}

.DBHealth_mariadbContent__3\\+PPP,
.DBHealth_mysqlContent__7zNTV,
.DBHealth_postgresqlContent__JL6BT {
  padding: 20px;
}
.DBHealth_mariadbContent__3\\+PPP h2,
.DBHealth_mysqlContent__7zNTV h2,
.DBHealth_postgresqlContent__JL6BT h2 {
  margin-bottom: 24px;
  color: #1D283C;
}
.DBHealth_mariadbContent__3\\+PPP p,
.DBHealth_mysqlContent__7zNTV p,
.DBHealth_postgresqlContent__JL6BT p {
  margin-bottom: 32px;
  color: #666;
  line-height: 1.6;
}

.DBHealth_statsContainer__rwoiC {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.DBHealth_statCard__lTFhv {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1;
}
.DBHealth_statCard__lTFhv h3 {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
}
.DBHealth_statCard__lTFhv .DBHealth_statValue__7g2k3 {
  font-size: 24px;
  font-weight: 600;
  color: #1D283C;
}`, "",{"version":3,"sources":["webpack://./src/pages/DBHealth/DBHealth.module.scss"],"names":[],"mappings":"AAAA;;;EAGE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;;;EAGE,aAAA;AACF;AACE;;;EACE,mBAAA;EACA,cAAA;AAGJ;AAAE;;;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AAIJ;;AAAA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,SAAA;AAGF;AADE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAGJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAEJ","sourcesContent":[".mariadbPage,\n.mysqlPage,\n.postgresqlPage {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.mariadbContent,\n.mysqlContent,\n.postgresqlContent {\n  padding: 20px;\n  \n  h2 {\n    margin-bottom: 24px;\n    color: #1D283C;\n  }\n  \n  p {\n    margin-bottom: 32px;\n    color: #666;\n    line-height: 1.6;\n  }\n}\n\n.statsContainer {\n  display: flex;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.statCard {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  flex: 1;\n  \n  h3 {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 12px;\n  }\n  \n  .statValue {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1D283C;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mariadbPage": `DBHealth_mariadbPage__vfoLf`,
	"mysqlPage": `DBHealth_mysqlPage__wzb9D`,
	"postgresqlPage": `DBHealth_postgresqlPage__fX+vg`,
	"mariadbContent": `DBHealth_mariadbContent__3+PPP`,
	"mysqlContent": `DBHealth_mysqlContent__7zNTV`,
	"postgresqlContent": `DBHealth_postgresqlContent__JL6BT`,
	"statsContainer": `DBHealth_statsContainer__rwoiC`,
	"statCard": `DBHealth_statCard__lTFhv`,
	"statValue": `DBHealth_statValue__7g2k3`
};
export default ___CSS_LOADER_EXPORT___;
